import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetAdjustmentDetail  {
    _originalTypeClassName = "zERP.BO.BudgetAdjustmentDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetAdjustmentDetail.translate = translateService;
}
this.Modification = new Domain.BudgetAdjustment();
this.Id = null;
this.Amount = null;
this.ApprovedAmount = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Amount:any;
ApprovedAmount:any;
Modification:any;
BudgetDetail:any;
BudgetItem:any;
static setModification = ($this, value) => {
var oldValue = $this.Modification;
$this.Modification = value;
if (value != null) {
if (oldValue != null) {
Domain.BudgetAdjustment.removeModifications(oldValue, $this);
}
Domain.BudgetAdjustment.addModifications(value, $this);
}
}
static setBudgetDetail = ($this, value) => {
var oldValue = $this.BudgetDetail;
$this.BudgetDetail = value;
if (value != null) {
if (oldValue != null) {
Domain.BudgetDetail.removeAdjustments(oldValue, $this);
}
Domain.BudgetDetail.addAdjustments(value, $this);
}
}
static setBudgetItem = ($this, value) => {
var oldValue = $this.BudgetItem;
$this.BudgetItem = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}